import PassholderDetails from "./PassholderDetails";
import './passholderDetails.scss';

export default PassholderDetails;